import axios from 'axios';
import { makeAutoObservable } from 'mobx';

import Court from './models/Court';

export default class CourtStore {
    constructor() {
        makeAutoObservable(this);
    }

    async find() {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/courts?filters[populate][]=players&size=1000`);
        return data.courts.map((court: any) => new Court().fromJSON(court)) as Court[];
    }

    async findById(id: string) {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/courts/${id}`);
        return new Court().fromJSON(data);
    }

    static async find() {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/courts?filters[populate][]=players&size=1000`);
        return data.courts.map((court: any) => new Court().fromJSON(court)) as Court[];
    }

    static async saveById(id: string, formData: any) {
        const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/courts/${id}`, formData);
        return new Court().fromJSON(data);
    }
}
